import { KulionerReceiptSectionProps } from "../types";
import { colors } from "../constants";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { ellipsisString } from "@/app/infrastructures/misc/Utils";

export const renderContactInfo = ({
  doc,
  x,
  y
}: KulionerReceiptSectionProps): number => {
  doc.setFontSize(6);
  doc.setFont("helvetica", "normal");
  doc.setTextColor(colors.lightGray);
  y += 4;
  doc.text(AccountController.accountData.phone_number, x, y);
  y += 3;
  doc.text(
    ellipsisString(
      AccountController.accountData.account_type_detail.address,
      70
    ),
    x,
    y
  );
  return y;
};
